module.exports = __webpack_public_path__ + "static/media/promo.ca26ed1b.png";